import { getAccountListInfo, updateAvatar, getAreaList, getCampusList } from '@/api/mine/mine';

const mine = {
  state: {
    userInfo: []
  },

  mutations: {
    SET_USER_INFO: (state, data) => {
      state.userInfo = data;
    }
  },

  actions: {
    // 获取会员账户详细信息
    getAccountListInfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        getAccountListInfo(data).then(res => {
          console.log('res', res.data);
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 替换头像
    updateUserAvatar({ commit }, data) {
      console.log('data', data);
      return new Promise((resolve, reject) => {
        updateAvatar(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 获取联动地址
    getAreaData({ commit }) {
      return new Promise((resolve, reject) => {
        getAreaList().then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 获取校区列表
    GetCampusList({ commit }, data) {
      return new Promise((resolve, reject) => {
        getCampusList(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    }
  }
};

export default mine;



// WEBPACK FOOTER //
// ./src/store/mine.js